const { iterateKeySet } = require('falcor-path-utils');
const clone = require('lodash/clone');
const isArray = require('lodash/isArray');
const isString = require('lodash/isString');

const join = require('./join');
const split = require('./split');

/**
 * Expand a query pathSet with range expressions or multiple values into an array of individual
 * paths
 * @param {QueryPathSet} pathSet the path expression to expand
 * @param {boolean} [returnString] `true` to return string paths, `false` to return paths in Falcor
 * Array syntax
 * @returns {Array<LeafPath<string>>|Array<LeafPath<Array>>} the expanded individual paths
 * @example
 *   expand('fx.pairs[0..2]["bid", "ask"]', true);
 *   // => [
 *   //  'fx.pairs[0].bid',
 *   //  'fx.pairs[0].ask',
 *   //  'fx.pairs[1].bid',
 *   //  'fx.pairs[1].ask',
 *   //  'fx.pairs[2].bid',
 *   //  'fx.pairs[2].ask',
 *   // ]
 *
 *   expand(['fx'], ['pairs'], [{ from: 0, to: 2 }], ['bid', 'ask']]);
 *   // => [
 *   //  ['fx', 'pairs', 0, 'bid'],
 *   //  ['fx', 'pairs', 0, 'ask'],
 *   //  ['fx', 'pairs', 1, 'bid'],
 *   //  ['fx', 'pairs', 1, 'ask'],
 *   //  ['fx', 'pairs', 2, 'bid'],
 *   //  ['fx', 'pairs', 2, 'ask'],
 *   // ]
 */
function expand(pathSet = /* istanbul ignore next */ '',
                returnString = /* istanbul ignore next */ false) {
  const pathSetArray = isArray(pathSet) ? pathSet : split(pathSet);

  const expandedPaths = expandArray(pathSetArray);

  if (isString(pathSet) || returnString) {
    return expandedPaths.map((pathArray) => join(pathArray));
  }

  return expandedPaths;
}

function expandArray(pathArray) {
  const allPaths = [];
  spread(pathArray, 0, allPaths);
  return allPaths;
}

/*
 THIS CODE DIRECT FROM FALCOR
 */
/* eslint-disable no-param-reassign */
function spread(pathSet, depth, out, currentPath = []) {
  if (depth === pathSet.length) {
    out[out.length] = clone(currentPath);
    return;
  }

  // Simple case
  const key = pathSet[depth];
  /* istanbul ignore next: typeof oddness */
  if (typeof key !== 'object') {
    currentPath[depth] = key;
    spread(pathSet, depth + 1, out, currentPath);
    return;
  }

  // complex key.
  const iteratorNote = {};
  let innerKey = iterateKeySet(key, iteratorNote);
  do {
    // spreads the paths
    currentPath[depth] = innerKey || 0;
    spread(pathSet, depth + 1, out, currentPath);
    currentPath.length = depth;

    innerKey = iterateKeySet(key, iteratorNote);
  } while (!iteratorNote.done);
}

module.exports = expand;
